import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { BookCategoryForm } from "../BookCategoryForm";
import { EditCategoryModalProps } from "./types";
import { useEditBookCategoryModal } from "./controller";

export const EditBookCategoryModal = React.memo(({ modalRef, onComplete }: EditCategoryModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditBookCategoryModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_category_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <BookCategoryForm />
    </Modal>
  );
});
